var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "input-data-wrapper" },
    [
      _vm.useNewInterface
        ? [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "nd-modos" }, [
              _c(
                "div",
                {
                  staticClass: "nd-modo-option",
                  on: {
                    click: function ($event) {
                      return _vm.handleModeChange("proximas")
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "nd-radio-btn",
                      style:
                        _vm.searchMode === "proximas"
                          ? { borderColor: _vm.primaryColor }
                          : {},
                    },
                    [
                      _vm.searchMode === "proximas"
                        ? _c("div", {
                            staticClass: "nd-radio-inner",
                            style: { backgroundColor: _vm.primaryColor },
                          })
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "nd-modo-label",
                      class: {
                        "nd-modo-label--active": _vm.searchMode === "proximas",
                      },
                    },
                    [_vm._v("\n          Próximas saídas\n        ")]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "nd-modo-option",
                  on: {
                    click: function ($event) {
                      return _vm.handleModeChange("por-mes")
                    },
                  },
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "nd-radio-btn",
                      style:
                        _vm.searchMode === "por-mes"
                          ? { borderColor: _vm.primaryColor }
                          : {},
                    },
                    [
                      _vm.searchMode === "por-mes"
                        ? _c("div", {
                            staticClass: "nd-radio-inner",
                            style: { backgroundColor: _vm.primaryColor },
                          })
                        : _vm._e(),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      staticClass: "nd-modo-label",
                      class: {
                        "nd-modo-label--active": _vm.searchMode === "por-mes",
                      },
                    },
                    [_vm._v("\n          Escolher por mês\n        ")]
                  ),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("hr", { staticClass: "nd-divider" }),
            _vm._v(" "),
            _vm.searchMode === "por-mes"
              ? _c("div", { staticClass: "nd-month-select-wrap" }, [
                  _c("i", {
                    staticClass: "fa-regular fa-calendar-days nd-month-icon",
                  }),
                  _vm._v(" "),
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.selectedMonth,
                          expression: "selectedMonth",
                        },
                      ],
                      staticClass: "nd-month-select",
                      on: {
                        change: [
                          function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.selectedMonth = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                          _vm.handleMonthChange,
                        ],
                      },
                    },
                    _vm._l(_vm.availableMonths, function (m) {
                      return _c(
                        "option",
                        { key: m.key, domProps: { value: m.key } },
                        [
                          _vm._v(
                            "\n          " + _vm._s(m.label) + "\n        "
                          ),
                        ]
                      )
                    }),
                    0
                  ),
                  _vm._v(" "),
                  _c("i", {
                    staticClass: "fas fa-chevron-down nd-month-chevron",
                  }),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.loadingAll
              ? _c(
                  "p",
                  { staticClass: "nd-counter" },
                  [
                    _vm.searchMode === "proximas"
                      ? [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.filteredDateItems.length) +
                              _vm._s(_vm.hasMoreToLoad ? "+" : "") +
                              " saídas encontradas\n      "
                          ),
                        ]
                      : _vm.selectedMonth
                      ? [
                          _vm._v(
                            "\n        " +
                              _vm._s(_vm.selectedMonthItems.length) +
                              " saídas encontradas em " +
                              _vm._s(_vm.selectedMonthLabel) +
                              "\n      "
                          ),
                        ]
                      : _vm._e(),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.loadingAll
              ? _c("div", { staticClass: "nd-loading" }, [
                  _c("i", { staticClass: "fa-regular fa-hourglass" }),
                ])
              : _c(
                  "div",
                  { staticClass: "nd-list" },
                  _vm._l(_vm.currentModeItems, function (item) {
                    return _c(
                      "div",
                      {
                        key: item.dateStr,
                        staticClass: "nd-card",
                        class: {
                          "nd-card--selected": _vm.isSelected(item),
                          "nd-card--disabled": item.esgotado,
                        },
                        style: _vm.getNewCardStyle(item),
                        on: {
                          click: function ($event) {
                            return _vm.onCardClick(item)
                          },
                        },
                      },
                      [
                        _c(
                          "div",
                          { staticClass: "nd-card-body" },
                          [
                            _c("div", { staticClass: "nd-dep" }, [
                              _c("span", { staticClass: "nd-label" }, [
                                _vm._v("Saída"),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "nd-date" }, [
                                _vm._v(_vm._s(item.depDateCompact)),
                              ]),
                              _vm._v(" "),
                              _c("span", { staticClass: "nd-weekday" }, [
                                _vm._v(_vm._s(item.depWeekdayFull)),
                              ]),
                            ]),
                            _vm._v(" "),
                            item.retDay
                              ? [
                                  _c("div", { staticClass: "nd-connector" }, [
                                    _c("span", {
                                      staticClass: "nd-connector-dot",
                                      style: {
                                        backgroundColor: _vm.isSelected(item)
                                          ? _vm.primaryColor
                                          : "#aaaaaa",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "nd-connector-line",
                                      style: {
                                        backgroundColor: _vm.isSelected(item)
                                          ? _vm.primaryColor
                                          : "#aaaaaa",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("i", {
                                      staticClass:
                                        "fas fa-arrow-right nd-connector-arrow",
                                      style: {
                                        color: _vm.isSelected(item)
                                          ? _vm.primaryColor
                                          : "#aaaaaa",
                                      },
                                    }),
                                  ]),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "nd-ret" }, [
                                    _c("span", { staticClass: "nd-label" }, [
                                      _vm._v("Retorno"),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      { staticClass: "nd-date nd-date--ret" },
                                      [_vm._v(_vm._s(item.retDateCompact))]
                                    ),
                                    _vm._v(" "),
                                    _c("span", { staticClass: "nd-weekday" }, [
                                      _vm._v(_vm._s(item.retWeekdayFull)),
                                    ]),
                                  ]),
                                ]
                              : _c("div", { staticClass: "nd-spacer" }, [
                                  item.bateVolta
                                    ? _c(
                                        "span",
                                        {
                                          staticClass: "nd-bate-volta-badge",
                                          style: {
                                            backgroundColor: _vm.hexToRgba(
                                              _vm.primaryColor,
                                              0.12
                                            ),
                                            color: _vm.primaryColor,
                                          },
                                        },
                                        [
                                          _c("i", {
                                            staticClass: "fas fa-bolt",
                                          }),
                                          _vm._v(" Bate-volta\n            "),
                                        ]
                                      )
                                    : _vm._e(),
                                ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "nd-radio-sel",
                                style: _vm.isSelected(item)
                                  ? { borderColor: _vm.primaryColor }
                                  : {},
                              },
                              [
                                _vm.isSelected(item)
                                  ? _c("div", {
                                      staticClass: "nd-radio-inner-sel",
                                      style: {
                                        backgroundColor: _vm.primaryColor,
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        item.esgotado
                          ? _c("div", { staticClass: "nd-vagas-esgotadas" }, [
                              _c("i", { staticClass: "fa-regular fa-user" }),
                              _vm._v(" Vagas Esgotadas\n        "),
                            ])
                          : _c(
                              "div",
                              {
                                staticClass: "nd-vagas-poucas",
                                style: {
                                  opacity:
                                    item.vagasRestantes !== null &&
                                    item.vagasRestantes <= 5 &&
                                    !item.esgotado
                                      ? 1
                                      : 0,
                                },
                              },
                              [
                                _c("i", { staticClass: "fa-regular fa-user" }),
                                _vm._v(
                                  " Apenas " +
                                    _vm._s(item.vagasRestantes) +
                                    " " +
                                    _vm._s(
                                      item.vagasRestantes === 1
                                        ? "vaga restante"
                                        : "vagas restantes"
                                    ) +
                                    "\n        "
                                ),
                              ]
                            ),
                      ]
                    )
                  }),
                  0
                ),
            _vm._v(" "),
            !_vm.loadingAll &&
            !_vm.loadingMore &&
            _vm.searchMode === "proximas" &&
            _vm.hasMoreProximas
              ? _c(
                  "div",
                  {
                    staticClass: "nd-btn-mais",
                    style: {
                      borderColor: _vm.primaryColor,
                      color: _vm.primaryColor,
                    },
                    on: { click: _vm.handleShowMore },
                  },
                  [_vm._v("\n      Mostrar mais datas\n    ")]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.loadingMore && !_vm.loadingAll
              ? _c("div", { staticClass: "nd-loading" }, [
                  _c("i", { staticClass: "fa-regular fa-hourglass" }),
                ])
              : _vm._e(),
          ]
        : [
            _c("div", { staticClass: "input-data-lista" }, [
              _c("div", { staticClass: "lista-header" }, [
                _c("div", { staticClass: "lista-header-title" }, [
                  _c("i", {
                    staticClass:
                      "fa-regular fa-calendar-days lista-header-icon",
                  }),
                  _vm._v(" "),
                  _c("strong", { staticClass: "lista-header-text" }, [
                    _vm._v(_vm._s(_vm.titulo)),
                  ]),
                ]),
                _vm._v(" "),
                _vm.totalDates > 0 && !_vm.loadingMore && !_vm.hasMoreToLoad
                  ? _c("span", { staticClass: "lista-badge" }, [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.totalDates) +
                          " " +
                          _vm._s(
                            _vm.totalDates === 1
                              ? "data disponível"
                              : "datas disponíveis"
                          ) +
                          "\n        "
                      ),
                    ])
                  : _vm._e(),
              ]),
              _vm._v(" "),
              _vm.visibleDateItems.length > 0
                ? _c(
                    "div",
                    { staticClass: "date-list" },
                    _vm._l(_vm.visibleDateItems, function (item, idx) {
                      return _c(
                        "div",
                        {
                          key: idx,
                          staticClass: "date-card",
                          class: {
                            "date-card--selected": _vm.isSelected(item),
                            "date-card--disabled": item.esgotado,
                          },
                          style: _vm.getCardStyle(item),
                          on: {
                            click: function ($event) {
                              return _vm.onCardClick(item)
                            },
                          },
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "date-card-row" },
                            [
                              _c("div", { staticClass: "date-block" }, [
                                _c("span", { staticClass: "date-day" }, [
                                  _vm._v(_vm._s(item.depDay)),
                                ]),
                                _vm._v(" "),
                                _c("span", { staticClass: "date-month" }, [
                                  _vm._v(_vm._s(item.depMonth)),
                                ]),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "date-weekday-block",
                                  class: {
                                    "date-weekday-block--bate-volta":
                                      item.bateVolta,
                                  },
                                },
                                [
                                  item.bateVolta
                                    ? [
                                        _c(
                                          "span",
                                          { staticClass: "date-weekday-full" },
                                          [_vm._v(_vm._s(item.depWeekdayFull))]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "date-full-date" },
                                          [_vm._v(_vm._s(item.depFullDate))]
                                        ),
                                      ]
                                    : [
                                        _c(
                                          "span",
                                          { staticClass: "date-label-tag" },
                                          [_vm._v("Saída")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "date-weekday-name" },
                                          [_vm._v(_vm._s(item.depWeekday))]
                                        ),
                                      ],
                                ],
                                2
                              ),
                              _vm._v(" "),
                              item.retDay
                                ? _c("div", { staticClass: "date-connector" }, [
                                    _c("span", {
                                      staticClass: "connector-line",
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "connector-dot",
                                      style: {
                                        backgroundColor: _vm.primaryColor,
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass: "connector-line",
                                    }),
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              item.retDay
                                ? [
                                    _c("div", { staticClass: "date-block" }, [
                                      _c("span", { staticClass: "date-day" }, [
                                        _vm._v(_vm._s(item.retDay)),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        { staticClass: "date-month" },
                                        [_vm._v(_vm._s(item.retMonth))]
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "date-weekday-block" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "date-label-tag" },
                                          [_vm._v("Retorno")]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "span",
                                          { staticClass: "date-weekday-name" },
                                          [_vm._v(_vm._s(item.retWeekday))]
                                        ),
                                      ]
                                    ),
                                  ]
                                : _c("div", { staticClass: "date-spacer" }, [
                                    item.bateVolta
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "bate-volta-badge",
                                            style: {
                                              backgroundColor: _vm.hexToRgba(
                                                _vm.primaryColor,
                                                0.12
                                              ),
                                              color: _vm.primaryColor,
                                            },
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "fas fa-bolt",
                                            }),
                                            _vm._v(
                                              " Bate-volta\n              "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "selection-circle",
                                  style: _vm.isSelected(item)
                                    ? {
                                        backgroundColor: _vm.primaryColor,
                                        borderColor: _vm.primaryColor,
                                      }
                                    : {},
                                },
                                [
                                  _vm.isSelected(item)
                                    ? _c("i", {
                                        staticClass:
                                          "fa-solid fa-check selection-check",
                                      })
                                    : _vm._e(),
                                ]
                              ),
                            ],
                            2
                          ),
                          _vm._v(" "),
                          item.esgotado
                            ? _c(
                                "div",
                                { staticClass: "vagas-row vagas-esgotadas" },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-user",
                                  }),
                                  _vm._v(" Vagas Esgotadas\n          "),
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "vagas-row vagas-poucas",
                                  style: {
                                    opacity:
                                      item.vagasRestantes !== null &&
                                      item.vagasRestantes <= 5 &&
                                      !item.esgotado
                                        ? 1
                                        : 0,
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fa-regular fa-user",
                                  }),
                                  _vm._v(
                                    " Apenas " +
                                      _vm._s(item.vagasRestantes) +
                                      " " +
                                      _vm._s(
                                        item.vagasRestantes === 1
                                          ? "vaga restante"
                                          : "vagas restantes"
                                      ) +
                                      "\n          "
                                  ),
                                ]
                              ),
                        ]
                      )
                    }),
                    0
                  )
                : !_vm.loadingMore
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "font-style": "italic",
                      },
                    },
                    [_vm._v("\n        Nenhuma data disponível\n      ")]
                  )
                : _vm._e(),
              _vm._v(" "),
              !_vm.loadingMore && (_vm.hiddenCount > 0 || _vm.hasMoreToLoad)
                ? _c(
                    "div",
                    {
                      staticClass: "toggle-datas",
                      style: { color: _vm.primaryColor },
                      on: { click: _vm.handleToggle },
                    },
                    [
                      _c("i", { staticClass: "fa-solid fa-chevron-down" }),
                      _vm._v(
                        " Ver mais " +
                          _vm._s(
                            !_vm.hasMoreToLoad && _vm.hiddenCount > 0
                              ? _vm.hiddenCount +
                                  " " +
                                  (_vm.hiddenCount === 1 ? "data" : "datas")
                              : "datas"
                          ) +
                          "\n      "
                      ),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.loadingMore
                ? _c(
                    "div",
                    {
                      staticStyle: {
                        "text-align": "center",
                        "margin-top": "10px",
                      },
                    },
                    [_c("i", { staticClass: "fa-regular fa-hourglass" })]
                  )
                : _vm._e(),
            ]),
          ],
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "nd-header" }, [
      _c("strong", { staticClass: "nd-header-title" }, [
        _vm._v("Datas disponíveis"),
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "nd-header-subtitle" }, [
        _vm._v(
          "\n        Escolha como deseja buscar sua data para ver as saídas disponíveis.\n      "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }